import { Divider } from '@looker/components';
import { BISwitch } from '@pulsepointinc/bi-components';
import React, { type FC } from 'react';
import type { Filter } from '../../../../../stores/filters';
import ExpressionTypeSelector from '../CustomFilterComponents/ExpressionTypeSelector';
import { useSwitchFilterControl } from './hooks/useSwitchButtonFilterControl';
import { Container, SwitchWrapper } from './styles';

interface FilterProps {
  filterName: string;
  startingState: Record<string, boolean>;
  isDense?: boolean;
  categories: string[];
  onChange?: (value: string) => void;
  onExpressionTypeChange?: (value: string) => void;
  onMultiFilterChange?: (filter: Filter) => void;
}

const SwitchButtonFilterControl: FC<FilterProps> = ({
  filterName,
  startingState,
  categories,
  isDense,
  onMultiFilterChange,
  onChange,
  onExpressionTypeChange,
}) => {
  const { handleExpressionTypeChange, handleToggleChange, switchState, toggleableFilter } = useSwitchFilterControl({
    filterName,
    startingState,
    categories,
    onMultiFilterChange,
    onChange,
    onExpressionTypeChange,
  });

  if (switchState === null) {
    return null;
  }

  return (
    <Container dense={isDense}>
      {toggleableFilter && (
        <ExpressionTypeSelector filterName={filterName} onExpressionTypeChange={handleExpressionTypeChange} />
      )}
      <div>
        {categories.map((category, index) => (
          <React.Fragment key={category}>
            <SwitchWrapper>
              <BISwitch
                switchLabel={category}
                checked={switchState[category]}
                onToggleChange={(toggle) => handleToggleChange(category, toggle)}
              />
            </SwitchWrapper>
            {index < categories.length - 1 && <Divider className="divider" />}
          </React.Fragment>
        ))}
      </div>
    </Container>
  );
};

export default SwitchButtonFilterControl;
